<template>
 <v-container class="my-0 pt-1 pb-0 px-0">
        <v-row no-gutters v-if="o_loading" class="pa-2 ma-0">
            <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
        </v-row>
        <v-row no-gutters v-else class="flex-row pa-0 ma-0">
            <v-col v-if="show_action" cols="12" sm="12" md="2" class="d-flex align-start justify-end order-xs-1 order-sm-1 order-md-2 pb-0">
                <slot name="other_action"></slot>
                <v-btn
                    color="primary"
                    fab
                    small
                    v-if="operation.status"
                    v-can="{obj_type:'operation', action: 'remove'}"
                ><v-icon class="ma-2" small @click.stop="openDeleteConfirm">delete</v-icon></v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="10" class="d-flex cursor_pointer flex-column align-start justify-start order-xs-2 order-sm-2 order-md-1 pb-1" @click.stop.prevent="goToOperationDetails">
                <div class="d-flex full-width text-left">
                    <span>
                        <StatusIcon class="small mr-2" :status="operation.status" :tooltip_text="op_tooltip[operation.status]"/><b v-if="operation.name">{{operation.name}} - </b><b>{{ operation.order_date | formatDateTS }}</b> - intervento nr. <b>{{ operation.order_nr}}</b> del {{ operation.op_date  | formatDateTS }}<br/>
                        <i><b>{{ client.name }}</b> - {{ location.name }} - {{ location.address}} {{ location.addrNum }}, {{ location.city }} ({{ location.district }})</i><br/>
                        nr. strumenti: <b>{{operation.instrument_ids.length }}</b><br/>
                        <span v-if="operation.assigned && operation.assigned.length>0">
                            <i>Operatori: </i><b v-for="(uid, idx) of operation.assigned" :key="uid">{{ $store.state.users[uid].name }}<span v-if="idx< operation.assigned.length-1">, </span></b><br/>
                        </span>
                        
                    </span>
                </div>
                <!--div  class="d-flex flex-grow-1 flex-shrink-0 caption justify-end">
                    creato il {{ operation.created | formatDateTS }}
                </div-->
                <!--div class="d-flex flex-shrink-1 flex-grow-0 text-left ml-2">{{getFormattedDate(operation.op_date)}}</div-->
            
            </v-col>
        </v-row>
    <ConfirmDialog
        v-bind:data="delete_confirm"
        v-on:close_dialog="closeDialog"
        v-on:confirm_result="onDeleteConfirm"/>
        
    </v-container>
</template>
<script>
// import _ from 'lodash'
import {report_type, operation_status_tooltip} from "../../utils/common.js"
import {getObjStatus} from "../../utils/commonUtils"

import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import StatusIcon from '../../components/utils/StatusIcon'


export default {
    components: {ConfirmDialog, StatusIcon},
    props:{ 
        "operation_id": {
            type: String,
            required: true,
            default: ''  // TODO DEBUG-ONLY
        },
        "show_action": {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data(){
        return {
            operation: {},
            client:{},
            location:{},
            op_types: report_type,
            delete_confirm: {
                index: null,
                dialog: false,
                doc: null,
                title: 'Elimina intervento',
                message: "Sei sicuro di voler rimuovere l'intervento selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                ]
            },
            deletable:false,
            o_loading: true,
            op_tooltip: operation_status_tooltip
        }
    },
    computed: {
        status() {
            if (this.operation) {
                let status = getObjStatus(this.$store.state.config.threshold, this.operation, null)
                return status
            }
            return ''
        },
            
    },
    async mounted() {
        await this.loadOperation()
        //console.log("mounted ", this.operation, this.client, this.location, this.instruments)
    },
    methods: {
        async loadOperation() {
            this.loading = true
            this.operation = await this.$store.state.$pouch.get('operations', this.operation_id)
            this.client = await this.$store.state.$pouch.get('registry', this.operation.client_id)
            this.location = await this.$store.state.$pouch.get('registry', this.operation.location_id)
            this.o_loading = false
        },
        getColor(verified) {
            let color = 'error'
            if (verified) {
                color = 'success'
            }
            console.log('getColor', color)
            return color
        },
        getOpName(op_type){
            return this.op_types.find(function(el){
                return el.id === op_type
            })
        },
        openDeleteConfirm(){
            console.log('DELETE')
            this.delete_confirm.dialog = true;
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    this.operation.updated = (new Date()).getTime()
                    this.operation.updated_by = this.$store.state.user._id
                    // this.operation._deleted = true
                    this.operation.dismissed = true
                    await this.$store.state.$pouch.put('operations', this.operation)
                    this.$emit('operation_removed')
                }
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },
        goToOperationDetails() {
            console.log('GO TO OPERATION EDIT')
            this.$router.push({path: "/operations/details", query: {"op_id": this.operation._id, "back": this.$router.history.current.fullPath}})
        },
        getStatus(obj, data) {
            if (!data){
                data = null
            }
            return getObjStatus(this.$store.state.config.threshold, obj, data)
        },
        
        /*goToOperationEdit() {
            console.log('GO TO OPERATION EDIT')
            this.$router.push({path: "/operations/editComplete", query: {"op_id": this.operation._id, "back": this.$router.history.current.fullPath}}) 
        },
        goToReportEdit(instr_id) {
            console.log('GO TO REPORT')
            this.$router.push({path: "/reports/edit", query: {"operation_id": this.operation._id, "instrument_id": instr_id, "back": this.$router.history.current.fullPath}}) 
        },
        goToInstrumentEdit(instr_id){
            //if(!this.disabledForNow){
                this.$router.push({name: "editInstrument", query: {"instrument_id": instr_id, "back": this.$router.history.current.fullPath }})
            //}
        }*/
    },
    
}

</script>